import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../helpers/axiosConfig';

// Fetch user profile
export const fetchUserProfile = createAsyncThunk(
  'myAccount/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/profile');
      return response.data.user;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch profile'
      );
    }
  }
);

// Change password
export const changePassword = createAsyncThunk(
  'myAccount/changePassword',
  async (
    { current_password, new_password, new_password_confirmation },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.post('/change-password', {
        current_password,
        new_password,
        new_password_confirmation,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to change password'
      );
    }
  }
);

// Delete account
export const deleteAccount = createAsyncThunk(
  'myAccount/deleteAccount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.delete('/delete/account');
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete account'
      );
    }
  }
);

const initialState = {
  user: null,
  loading: false,
  error: null,
  successMessage: null,
};

const myAccountSlice = createSlice({
  name: 'myAccount',
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch profile cases
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = {
          id: action.payload.id,
          name: action.payload.name,
          email: action.payload.email,
          phone: action.payload.phone,
          image: action.payload.image,
          points: action.payload.points,
          wallet: action.payload.wallet,
          type: action.payload.type,
        };
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Change password cases
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete account cases
      .addCase(deleteAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        state.user = null;
      })
      .addCase(deleteAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = myAccountSlice.actions;
export default myAccountSlice.reducer;
